import $ from 'jquery';

/**
 * Destination list with an image that follows the mouse over the hovered row
 * (.over-lines / .riga-over / .mouse-following-cont — home and
 * partial/_destinationgrey). The images are preloaded on the first scroll.
 */
export function initHoverLines() {
    if (!$('.riga-over').length) return;

    $('.riga-over').click(function (e) {
        $(e.target).parent().trigger('click');
    });

    $(window).one('scroll', function () {
        $('.riga-over').each(function (index) {
            let imgPreload = new Image();
            imgPreload.src = $(this).data('src');

            imgPreload.dataset.indice = index;

            $(this).data('indice', index);
            this.dataset.indice = index;

            $(imgPreload).data('indice', index);
            $(imgPreload).addClass('mouse-following-img');

            $(this).parents('.over-lines').find('.mouse-following-cont').append(imgPreload);
        });

        // One delegated handler; this used to be `$('*').mousemove(...)`, a
        // handler on every element of the page.
        $(document).on('mousemove', function (e) {
            let imgCont = $(e.target).parents('.over-lines').find('.mouse-following-cont');
            if ($(e.target).hasClass('riga-over')) {
                $('.riga-over').removeClass('selezionata');
                $(e.target).addClass('selezionata');

                imgCont.addClass('attivo');
                let indiceRiga = $(e.target).data('indice');
                let imgRef = imgCont.find("[data-indice='" + indiceRiga + "']");

                if (!imgRef.hasClass('attiva')) {
                    imgCont.find('img').fadeOut();
                    imgCont.find('img').removeClass('attiva');
                    imgRef.addClass('attiva');
                    imgRef.fadeIn();
                }

                let contX = e.pageX - imgCont.width() / 2;
                let contY = e.pageY - imgCont.height() / 2;

                let imgMove = (imgCont.width() - imgRef.width());
                let mouseXPercent = e.pageX * 100 / $('.over-lines').width();
                let imgX = mouseXPercent * imgMove / 100;

                imgRef.css({ left: imgX });
                imgCont.css({ left: contX, top: contY });
            } else {
                $('.mouse-following-cont').removeClass('attivo');
            }
        });
    });
}
